import useI18nGlobal from '@/utils/i18n';
const {i18n} = useI18nGlobal();
const { t } = i18n.global;

export const NODE_EDIT_DESIGN_OPTIONS = {
  SHAPE: {VALUE: 'SHAPE', get TITLE(){ return t('quickEditBar.shapeSettings')}, ICON: 'fas fa-shapes', ACTION: null},
  DESIGN: {VALUE: 'DESIGN', get TITLE(){return t('quickEditBar.nodeAppearance')}, ICON: 'fas fa-palette', ACTION: null},
  FONT: {VALUE: 'FONT', get TITLE(){ return t('quickEditBar.fontSettings')}, ICON: 'fas fa-font', ACTION: null},
};